module.exports = __webpack_public_path__ + "img/logo.c0df6668.png";